import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardAnalyticsRoute: InvariantJiraRoute = {
	name: 'dashboard-analytics',
	path: '/jira/dashboards/:dashboardId(\\w+-\\w+-\\w+-\\w+-\\w+)',
	exact: true,
};
